import { render, staticRenderFns } from "./PropertyFloorPlanImage.vue?vue&type=template&id=022c0080&"
import script from "./PropertyFloorPlanImage.vue?vue&type=script&lang=js&"
export * from "./PropertyFloorPlanImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports